import { createAsyncTypes } from '../utils'

export const getMostVisitedCommunesTypes = createAsyncTypes('GET_MOST_VISITED_COMMUNES')
